import { callAsync } from './call-async.js';
import { showModal } from '../core/bootstrap-helpers.js';
import { displayToastrAlert } from '../ui/toastr-alert.js';
import { formatCurrency } from '../core/utilities.js';

export function asyncPostOnload() {
    if (!$('.async-post-onload').length) {
        return;
    }
    var requests = {};
    var elements = {};
    $('.async-post-onload').each(function(k, asp) {
        if ($(this).attr('async-url') === undefined || $(this).attr('async-url') === false) {
            return;
        }
        var aspurl = $(this).attr('async-url');
        if (!requests.hasOwnProperty(aspurl)) {
            requests[aspurl] = {};
            elements[aspurl] = [];
        }
        elements[aspurl].push($(this));
        $.each(asp.attributes, function(ak, attr){
            if (attr.name.substring(0, 11) == 'async-post-') {
                var postfield = attr.name.substring(5) + '[' + k + ']';
                requests[aspurl][postfield] = attr.value;
            }
        });
    });
    $.each(requests, function(f_url, f_postData){  
        callAsync({
            url: f_url,
            postData: f_postData,
            callback: function(response){
                var c = 0;
                while(c < elements[f_url].length) {
                    var $element = elements[f_url][c]; 
                    var response_chunk = response[c] ?? response;
                    c++;
                    if ($element.attr('async-url') != f_url) {
                        return;
                    }
                    if ($element.attr('async-target-id') !== undefined && response_chunk.hasOwnProperty('html')) {
                        $('#' + $element.attr('async-target-id')).html(response_chunk.html);
                    }
                    if ($element.attr('async-callback') === undefined || $element.attr('async-callback') === false) {
                        console.log('async-post-onload #' + c + ' has no callback');
                        return;
                    }
                    var callback = {function: $element.attr('async-callback')};
                    window[callback.function](response_chunk, $element);
                }
            }
        });
    });
}

export function populateAsyncInventoryDisplay(response, $element) {
    var $stock_message_container = $element.find('.stock-message-container');
    var $your_cost_message_container = $element.find('.your-cost-message-container');
    var $locations_button_container = $element.find('.locations-button-container');
    var $locations_modal_container = $element.find('.locations-modal-container');
    var $locations_table_container = $element.find('.locations-table-container');
    var $description_container = $element.find('.description-container');
    
    if (response.hasOwnProperty('stock_message_class')) {
        $stock_message_container.addClass(response.stock_message_class);
    }
    $stock_message_container.html(response.stock_message);
    $your_cost_message_container.html(response.your_cost_message);
    if (response.hasOwnProperty('locations_table_html')) {
        $locations_table_container.html(response.locations_table_html);
    }
    if (response.hasOwnProperty('locations_modal_html')) {
        $locations_modal_container.html(response.locations_modal_html);
        $locations_button_container.html(response.locations_button_html);
    }
    
    if (response.hasOwnProperty('description') && response.description != '') {
        $description_container.html(response.description);
    }
    
    for (let index = 0; index < response.show_elements.length; ++index) {
        var show = response.show_elements[index];
        $element.find(show).removeClass('d-none');
    }
}

export function kitBuilderTableTotals() {
    totalCharges($('#kit-items'), $('#add_kit_items_button'));
}

export function totalCharges($group_container, $submit_button = null) {
    var $total = $('#' + $group_container.attr('total_container_id'));
    var total = 0;
    var are_valid_items = false;
    $group_container.find('.subtotal-elements').each(function() {
        var unit_price = $(this).find('.unit-price-input').val();
        var qty = $(this).find('.quantity-input').val();
        var no_aaia = ($(this).find('.aaia-hidden').val() == '');
        var inv = parseFloat($(this).find('.quantity-input').attr('available_inventory'));
        var $sub = $(this).find('.subtotal-display');
        var subtotal = (unit_price * qty);
        var subtotal_formatted = formatCurrency(subtotal);
        total += parseFloat(subtotal);
        if (subtotal == 0) {
            $sub.html('');
        } else {
            $sub.html('$' + subtotal_formatted);
            are_valid_items = true;
        }
        if (qty > inv || no_aaia) {
            if (no_aaia) {
                $(this).addClass('alert alert-default');
            } else {
                $(this).addClass('alert alert-danger');
            }
        } else {
            $(this).removeClass('alert alert-danger');
            $(this).removeClass('alert alert-default');
            $(this).addClass('kit-item-row');
        }
    });
    if (are_valid_items) {
        if ($submit_button != null) {
            $submit_button.removeAttr('disabled');
        }
        $total.html('$' + formatCurrency(total));
    } else {
        if ($submit_button != null) {
            $submit_button.attr('disabled', 'disabled');
        }
        $total.html('$' + formatCurrency(0.00));
    }
}

export function displayResponseMessage(response, $element) {
    var message = '';
    var type = '';
    if (response.hasOwnProperty('success') && response.success != null && response.success !== false) {
        message = response.success;
        type = 'success';
    } else if (response.hasOwnProperty('error') && response.error != null && response.error !== false) {
        message = response.error;
        type = 'error';
    } else if ($element.attr('async-success-message')) {
        message = $element.attr('async-success-message');
        type = 'success';
    } else {
        message = 'Operation successful';
        type = 'success';
    }
    var container_id = $element.attr('async-message-id');
    if (container_id != null) {
        var $container = $('#' + container_id);
        $container.html(message);
        $container.removeClass('d-none');
    } else {
        displayToastrAlert(type, message);
    }
}

export function loadAltKitBuilderItemsModal(e) {
    var $row = $(e.target).closest('.kit-item-row');
    var $modal = $(document.documentElement).find('.alt-items-modal');
    $modal.find('.item-title').html($row.find('.item-title').text().trim());
    $modal.find('.alts-for').attr('kit-item-row-id', $row.attr('id'));
}

export function getAltKitBuilderItems(ignore_size = false) {
    var $modal = $(document.documentElement).find('.alt-items-modal');
    var cpostData = {};
    var $altsfor = $modal.find('.alts-for');
    var $row = $('#' + $altsfor.attr('kit-item-row-id'));
    cpostData.kit_id = $row.find('.kit-hidden').val();
    cpostData.component_id = $row.find('.component-hidden').val();
    cpostData.key_id = $row.find('.key-hidden').val();
    cpostData.qty = $row.find('.quantity-input').val();
    if (!ignore_size) {
        cpostData.size = $row.find('.size-input').val();
    }
    var $c_target = $modal.find('.kit-modal-results');
    $c_target.html('<div class="modal-body"><span class="loading"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading Alternate Parts...</span></div>');
    showModal($modal);
    callAsync(
        {
            url: 'kit-builder/ajaxGetAltItemsModalContent',
            $target: $c_target,
            postData: cpostData
        }
    );
}
